import { render } from "./Navbar.vue?vue&type=template&id=1e1ec96b&scoped=true"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=1e1ec96b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1ec96b"]])

export default __exports__